import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
// import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import { FormBuilder } from '@angular/forms';
import { AdvertisementDetailsComponent } from '../pages/advertisement-details/advertisement-details.component';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import * as XLSX from 'xlsx';


@Component({
  selector: 'app-addmodal',
  templateUrl: './addmodal.component.html',
  styleUrls: ['./addmodal.component.scss']
})
export class AddmodalComponent implements OnInit {
  PendingAdd: any;
  start_date: any;
  end_date: any;


  constructor(private dialogRef: MatDialogRef<AddmodalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
    private cdr: ChangeDetectorRef,private fb: FormBuilder
  )
   { }
rep_name:any
district:any
taluka:any;
delivery_mode:any
sub_type:any
state:any
country:any
prant_name:any
pincode: any
officer: any
disrepname: any
loginFY: any

  ngOnInit(): void {

    this.rep_name= this.data['rep_name']
        this.district= this.data['district_name']
        this.taluka= this.data['taluka_name']
        this.delivery_mode= this.data['delivery_mode']
        this.start_date = this.data['start_date']
        this.end_date = this.data['end_date']
        this.sub_type = this.data['sub_type']
        this.state = this.data['state']
        this.country = this.data['country']
        this.prant_name = this.data['prant_name']
        this.pincode= this.data['pincode']
        this.officer = this.data['officer']
        this.disrepname = this.data['disrepname']

        const selectedYear = sessionStorage.getItem('selectedYear') || '';

    const years = selectedYear.match(/\d{4}/g);

    let loginFY = '';

    if (years && years.length >= 2) {
      loginFY = `${years[0].slice(-2)}-${years[1].slice(-2)}`;
    }
        const req:any = {
    
          "fy":loginFY,
          "delivery_mode":this.delivery_mode,
          "district":this.district,
          "taluka":this.taluka,
          "rep_name":this.rep_name,
          "start_date" : this.start_date,
          "end_date" : this.end_date,
          "country":this.country,
          "state":this.state,
          "prant_name":this.prant_name,
          "sub_type":this.sub_type,
          "pincode":this.pincode,
          "officer":this.officer,
          "disrepname":this.disrepname,
        }

        console.log("req for add", req)

        
  this.service.getgetpendingAdd(req).subscribe((data:any) => {
    console.log("pending add=",data);
   this.PendingAdd = (data as any);;

 });
        
  }

  
   exportExcel(fileName): void {
      /* table id is passed over here */
      let element = document.getElementById('print-section');
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
  
      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  
      /* save to file */
      XLSX.writeFile(wb, fileName + '.xlsx');
    }
  
}
